import React, { createContext, useEffect, useState } from "react";
import { DefaultCountry, DefaultCustodyType, DefaultDataSource, storageService } from "../api";

const DEVELOPMENT_MODE: boolean = import.meta.env.VITE_DEVELOPMENT_MODE == "true";

export type Settings = {
    noCache: boolean;
    detailedResponses: boolean;
    country: DefaultCountry;
    custodyType: DefaultCustodyType;
    dataSource: DefaultDataSource;
    isDevMode: boolean;
    streaming: boolean;
    showInitMessage?: boolean;
    showFunctions?: boolean;
    showFunctionsResults?: boolean;
};

export const defaultChatSettings: Settings = {
    noCache: false,
    detailedResponses: false,
    country: DefaultCountry.USA,
    custodyType: DefaultCustodyType.Own,
    dataSource: DefaultDataSource.GDWWithAI,
    isDevMode: DEVELOPMENT_MODE,
    streaming: true,
    showInitMessage: false,
    showFunctions: DEVELOPMENT_MODE ?? false,
    showFunctionsResults: false
};

export const SettingsContext = createContext({
    chatSettings: defaultChatSettings,
    setChatSettings: (chatSettings: Settings) => {},
    isSettingsOpened: false,
    setIsSettingsOpened: (isOpen: boolean) => {}
});

export const SettingsContextProvider = (props: any) => {
    const setSettings = (chatSettings: Settings) => {
        setState(state => ({ ...state, chatSettings }));
    };
    const setIsSettingsOpened = (isOpen: boolean) => {
        setState(state => ({ ...state, isSettingsOpened: isOpen }));
    };

    const initState = {
        chatSettings: defaultChatSettings,
        isSettingsOpened: false,
        setIsSettingsOpened,
        setChatSettings: setSettings
    };

    const [state, setState] = useState(initState);
    const [isSettingsLoaded, setIsSettingsLoaded] = useState(false);

    useEffect(() => {
        isSettingsLoaded && storageService.setDefaultSettings(state.chatSettings);
    }, [isSettingsLoaded, state.chatSettings]);

    useEffect(() => {
        const chatSettings = storageService.getDefaultSettings();

        if (chatSettings) {
            setState(state => ({ ...state, chatSettings }));
        }

        setIsSettingsLoaded(true);
    }, []);

    return <SettingsContext.Provider value={state}>{props.children}</SettingsContext.Provider>;
};
